import { useTranslation } from 'react-i18next';
import MainDialogLayout from '@/components/ui/MainDialogLayout/MainDialogLayout';
import { useGetApi } from '@/hooks/UseApiCalls';
import { OverheadFeeScheduleDtoOut } from '@/models/out/OverheadFeeScheduleDtoOut';
import { formatDateLocale } from '@/helpers/dateHelper';
import { OVERHEAD_FEES_URL } from '@/helpers/overheadFees';
import OverheadFeeTables from './OverheadFeeTables';
import styles from './OverheadsDialog.module.css';

interface OverheadsDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * HAT-1493: the overheads in a window, from «ייצוא טבלה» on the transactions board. The office asked
 * for a window rather than another file to download.
 *
 * The schedule is read when the board mounts this, not when the window opens, so the window opens
 * at its final size instead of growing from a loading line to the tables.
 */
const OverheadsDialog = ({ open, onClose }: OverheadsDialogProps) => {
  const { t } = useTranslation();
  const { data: schedule, isLoading } = useGetApi<OverheadFeeScheduleDtoOut>(OVERHEAD_FEES_URL);

  return (
    <MainDialogLayout open={open} onOpenChange={(value: boolean) => !value && onClose()} title={t('overheadsTable')} maxWidth="860px" fitContent>
      <div className={styles.body}>
        <p className={styles.intro}>
          {t('fundSettingsInfoPage.overheadIntro')}
          {schedule && ` ${t('fundSettingsDocumentsPage.overheadEffectiveFrom', { date: formatDateLocale(schedule.effectiveFrom) })}`}
        </p>
        {isLoading ? (
          <p className={styles.intro}>{t('loading')}</p>
        ) : !schedule ? (
          <p className={styles.intro}>{t('fundSettingsDocumentsPage.overheadNotAvailable')}</p>
        ) : (
          <OverheadFeeTables schedule={schedule} />
        )}
      </div>
    </MainDialogLayout>
  );
};

export default OverheadsDialog;
